module.exports = __webpack_public_path__ + "static/media/icon_event_onlinepublicity.d95d656c.svg";